import { trackEvent } from '@Services/analytics/tracking.service.ts';

export const useAddOwnerAnalytics = () => {
  function reportActOnUboCenter(uboCount: number): void {
    trackEvent('Act on UBO center', { action: 'Owner list is complete', uboCount });
  }

  return { reportActOnUboCenter }
}